var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "font-weight-bold d-inline-flex align-items-center overflow-hidden border stolen-badge border-width-2 font-size-75 br-50 user-select-none bg-white",
      style: `--badge-color:${_vm.badgeColor};--text-color:${_vm.textColor};`,
      on: {
        click: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.$emit("click", $event)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex h-100 align-items-center px-2 stolen-badge-label",
        },
        [_vm._t("before-label"), _vm._v(_vm._s(_vm.label) + "\n    ")],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "px-1 stolen-badge-value" },
        [_vm._v(_vm._s(_vm.value)), _vm._t("after-value")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }